import { render, staticRenderFns } from "./pi-select-city.vue?vue&type=template&id=0e2dbec8&"
import script from "./pi-select-city.vue?vue&type=script&lang=js&"
export * from "./pi-select-city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports